<template>
  <div class="modal-card" style="margin: 0 auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Select Values Sets</p>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close"/>
    </header>
    <div class="modal-card-body">

      <div class="columns">
        <div class="column is-half ">
          <p class="title is-5">Add Values</p>
        </div>
        <div class="column is-half has-text-right">
          <Button
            :to="{
              name: 'values-editor'
            }"
            variant="primary"
            size="3_5"
            target="_blank"
          >
            Edit Values Sets
          </Button>
        </div>
      </div>
      <b-table
        v-bind:data="screen_sets"
        v-bind:loading="loading"
        checkable
        sticky-header
        :row-class="() => 'noBorder'"
        v-bind:checked-rows.sync="screen_sets_applied"
      >
        <b-table-column field="name" label="Name" searchable sortable>
          <!-- cell rendering -->
          <template #default="props">
            <span :class="[isBold(props.row) ? 'has-text-weight-bold' : '']">
              {{ props.row.name }}
            </span>
          </template>

          <!-- the filter input with a placeholder -->
          <template #searchable="props">
            <b-input
              v-model="props.filters[props.column.field]"
              placeholder="Search Values Sets..."
              icon="magnify"
              size="is-small"
            />
          </template>
        </b-table-column>
        
        <b-table-column
          field="created_at"
          label="Created"
          sortable
          v-slot="props"
        >
          <span class="has-text-grey-dark is-size-7">
            {{ formatDateForTemplate(props.row.created_at, props.row.is_template) }}
          </span>
        </b-table-column>
        
        <b-table-column
          field="updated_at"
          label="Last Updated"
          sortable
          v-slot="props"
        >
          <span class="has-text-grey-dark is-size-7">
            {{ formatDateForTemplate(props.row.updated_at, props.row.is_template) }}
          </span>
        </b-table-column>
      </b-table>
    </div>
    <div class="modal-card-foot">
      <b-button
        v-on:click="save"
        class="is-success is-right"
      >
        Apply
      </b-button>
    </div>
  </div>
</template>

<script>
import telemetry from '@frontend/api/Telemetry';
import { apiFetch } from '../../../api/api';
import { Button } from '@stakeui';

const VADIS_NAMES = new Set([
  'VADIS Women Empowerer',
  'VADIS Planet Protector',
  'VADIS Peace Protector',
  'VADIS Racial Equity Advocate',
  'VADIS Health Defender',
  'VADIS Friend of Animals',
  'VADIS Fair Player',
]);

export default {
  data() {
    return {
      loading: false,
      active: false,
      screen_sets: [],
      screen_sets_applied: [],
    };
  },
  components: {
    Button,
  },
  props: {
    // Other components can pass in values that are supplied separately that we don't want to return via the API, i.e.
    // deprecated personas. The additionalvalues array is then merged with the api response to provide a full list of
    // values for someone to choose from.
    additionalValues: Array,
    currentlyApplied: Array,
    callback: Function,
    editValuesSets: Function,
    vadisMode: Boolean,
  },
  methods: {
    activate: function() {
      this.active = true;
    },
    isBold(row) {
      if (this.vadisMode) return VADIS_NAMES.has(row.name);
      return row.is_template;
    },
    vadisSort(sets) {
      return [...sets].sort((a, b) => {
        const aVadis = VADIS_NAMES.has(a.name) ? 0 : a.is_template ? 2 : 1;
        const bVadis = VADIS_NAMES.has(b.name) ? 0 : b.is_template ? 2 : 1;
        return aVadis - bVadis;
      });
    },
    save: function() {
      // Remove metrics because otherwise the payload is too large
      let newValuesWithoutMetrics = this.screen_sets_applied.map(value => {
        const { metrics, ...rest } = value;
        return rest;
      });
      let oldValuesWithoutMetrics = this.currentlyApplied.map(value => {
        const { metrics, ...rest } = value;
        return rest;
      });
      console.log('CALLING VALUES APPLIED HERE')
      telemetry.track('Values Applied', {
        oldValues: oldValuesWithoutMetrics,
        newValues: newValuesWithoutMetrics,
      });
      this.callback.call(this, this.screen_sets_applied);
      this.$parent.close();
    },
    formatDate: function(dateString) {
      if (!dateString) return 'N/A';
      
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short'
        });
      } catch (error) {
        return 'Invalid Date';
      }
    },
    formatDateForTemplate: function(dateString, isTemplate) {
      if (isTemplate) {
        return '-';
      }
      return this.formatDate(dateString);
    },
  },
  computed: {},
  created: function() {
    this.loading = true;
    apiFetch('/api/v1/screen_sets/?light_serializer=true')
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          this.screen_sets.push(...data.screen_sets);
          const knownIds = this.screen_sets.reduce((acc, itm) => {
            acc[itm.id] = true;
            return acc;
          }, {});
          const appliedIds = this.currentlyApplied.map((itm, idx, arr) => {
            if (!(itm.id in knownIds)) {
              this.screen_sets.unshift(itm);
              knownIds[itm.id] = itm;
            }
            return itm.id;
          });
          if (this.additionalValues) {
            this.additionalValues.forEach((itm) => {
              if (!(itm.id in knownIds)) {
                this.screen_sets.unshift(itm);
              }
            });
          }
          this.screen_sets_applied.push(...this.screen_sets.filter((itm, idx, arr) => {
            return appliedIds.indexOf(itm.id) > -1;
          }));
          if (this.vadisMode) {
            this.screen_sets = this.vadisSort(this.screen_sets);
          }
          this.loading = false;
        });
  },
};
</script>

<style lang="scss">
</style>
